import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { CellProps, Column } from "react-table";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";
import { TimeHistoryFromEquipmentRequestDTO } from "../../models/Equipment/TimeHistoryFromEquipmentRequestDTO";
import { TimeHistoryFromEquipmentResponseDTO } from "../../models/Equipment/TimeHistoryFromEquipmentResponseDTO";
import { EquipmentService } from "../../services/EquipmentService";
import TableComponent from "../TableComponent";

interface CountersFromEquipmentProps {
    equipmentId: number
}

function CountersFromEquipment({ equipmentId }: CountersFromEquipmentProps) {
    const equipmentService = new EquipmentService();
    const { counterOptions } = useAvailableModulesContext();

    const [data, setData] = useState<TimeHistoryFromEquipmentResponseDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    const columns = React.useMemo<Column<object>[]>(() => {
        const baseColumns: Column<object>[] = [
            {
                Header: <FormattedMessage id="Screens.Equipments.CountersFromEquipment.Column1" />,
                accessor: "assistanceName",
                width: 12,
            },
            {
                Header: <FormattedMessage id="Screens.Equipments.CountersFromEquipment.Column2" />,
                accessor: "date",
                Cell: (props: CellProps<any>) => {
                    const date = new Date(props.cell.row.original.date);
                    return <span>{date ? Utilities.formatDate(date) : "-"}</span>;
                },
                width: 12,
            },
        ];

        const counterColumns: Column<object>[] = counterOptions.map((option, index) => ({
            Header: option.split(";")[0],
            accessor: `timeHistory.counter${index + 1}`,
            width: 12,
            Cell: (props: CellProps<any>) => {
                const counterValue = props.cell.row.original.timeHistory?.[`counter${index + 1}`];
                return <span>{counterValue ? `${counterValue} ${option.split(";")[1]}` : "-"}</span>;
            },
        }));

        return [...baseColumns, ...counterColumns];
    }, [counterOptions]);

    const GetTimeHistoryFromEquipment = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const search: TimeHistoryFromEquipmentRequestDTO = {
            equipmentId: equipmentId,
            currentPage: currentPage,
            pageSize: pageSize,
        }

        var response = await equipmentService.GetTimeHistoryFromEquipment(search);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        setData(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    useEffect(() => {
        if (equipmentId !== 0) {
            GetTimeHistoryFromEquipment(currentPage ?? 1, pageSize ?? 5)
        }
    }, [equipmentId, currentPage, pageSize])

    return (
        <div>
            <label style={{ margin: "0px", padding: "13px" }}><b><FormattedMessage id="Screens.EquipmentCreate.Counters" /></b></label>
            <TableComponent
                columns={columns}
                data={data}
                goToPage={goToPage}
                initialPage={currentPage}
                pageCount={pageCount}
                initialPageSize={pageSize}
                pageSizes={pageSizes}
                manualPagination={true}
                loading={isLoading}
                fetchData={GetTimeHistoryFromEquipment}
                initialSortBy={[]}
                disableSortBy={true}
            />
        </div>
    )
}

export default CountersFromEquipment;